import { useQuery } from "@tanstack/react-query";
import { getNewMembersEnrollment } from "../../service/query/auth";

export const useGetNewMembersEnrollmentReport = ({ payload, page }) => {
  const newMembersEnrollement = useQuery({
    queryKey: ["newMembersEnrollmentReport", payload, page],
    queryFn: () => getNewMembersEnrollment({ ...payload, page }),
    enabled: !!payload && !!page,
    keepPreviousData: true,
  });
  return { data: newMembersEnrollement?.data?.data, ...newMembersEnrollement };
};
